/**
 * Destek ekranının iki yarısı: destek kayıtları ve Yenilikler.
 *
 * Yenilikler eskiden kendi ekranıydı (`/yenilikler`) ve menüde Destek'in hemen
 * üstünde ikinci bir satırdı. İkisi tek ekranda birleşti; bu dosya, adresin
 * hangi yarıyı açtığına karar veren TEK yer. Saf bir modül — React yok — çünkü
 * aynı soruyu sayfanın kendisi de üst çubuktaki sorun bildirme düğmesi de
 * soruyor, ve ikisi farklı cevap verirse düğme yanlış ekranı fotoğraflar.
 * Yenilikler'in adresini de buradan alıyorlar: Yenilikler penceresinin «Tüm
 * sürümler»i ve menü satırının yarıları (`nav.ts`, ⌘K ve Roller ekranı).
 *
 * NEDEN `sekme`: depodaki her çok yarılı ekranın anahtarı bu (Taleplerim,
 * Duyurular). `yeni` değil — o kayıt penceresini açıyor; `kume=yenilikler`
 * değil — tanımadığı kümeyi sessizce «Tümü»ne çeviriyor.
 *
 * VARSAYILAN ADRESE YAZILMIYOR. Destek yarısı `sekme`siz `/destek`: bugüne
 * kadar üretilmiş her bağlantı — sunucu bildirimlerindeki `?kayit=`, aramadaki
 * `?q=` ve `?yeni=`, mesajlaşmanın kayıt bağlantıları — bir harfi değişmeden
 * aynı yere düşüyor.
 */
export type DestekSekmesi = 'destek' | 'yenilikler';

export const SEKME_PARAM = 'sekme';
export const YENILIKLER_SEKMESI = 'yenilikler';

/**
 * Yenilikler'in adresi — sunucunun yazdığı eski `/yenilikler` buraya yönleniyor
 * (App.tsx). Dizenin yazımı sabit: kayıtlı bildirim satırları ve yer imleri
 * ona bağlı, `destek-sekmesi.test.ts` onu kilitliyor.
 */
export const YENILIKLER_ADRESI = `/destek?${SEKME_PARAM}=${YENILIKLER_SEKMESI}`;

/**
 * Adres hangi yarıyı açıyor — öncelik sırasıyla:
 *
 * 1. Destek kayıtlarını görme yetkisi (`support.read_own`) yoksa her zaman
 *    Yenilikler. Sürüm notları herkesin; tek yarı kalan biri için adres ne
 *    derse desin ekran o yarı.
 * 2. `kayit` varsa Destek. Geniş ekranda kayıt paneli YALNIZ kuyruğun yan
 *    sütununda bağlanabiliyor; Yenilikler açıkken `?kayit=` hiçbir şey
 *    göstermezdi — bildirimden gelen okuyucu boş bir ekrana bakardı.
 * 3. `sekme=yenilikler` ise Yenilikler.
 * 4. Gerisi — tanınmayan ya da boş `sekme` dahil — Destek.
 *
 * `yeni` bilerek SEKME SEÇMİYOR: başlıktaki düğmeye Yenilikler'deyken
 * basılınca kayıt penceresi sürüm notlarının üstünde açılıyor ve kapanınca
 * okuyucu kaldığı yerde.
 */
export function destekSekmesi(params: URLSearchParams, destekVar: boolean): DestekSekmesi {
  if (!destekVar) return 'yenilikler';
  if (params.get('kayit') !== null) return 'destek';
  return params.get(SEKME_PARAM) === YENILIKLER_SEKMESI ? 'yenilikler' : 'destek';
}

/**
 * Okuyucu şu anda destek KAYITLARINA mı bakıyor?
 *
 * DST-00078'in kuralı yalnız bu yarı için: kayıt listesinin görüntüsü bir
 * sorunu anlatmıyor, o yüzden oradan açılan bildirim ekran görüntüsü ve adres
 * almıyor. Yenilikler yarısı başka bir ekran — orada bir sürüm notu yanlış
 * görünüyorsa görüntüsü tam olarak sorunun kendisi.
 */
export function destekKayitEkraninda(
  pathname: string,
  search: string,
  destekVar: boolean,
): boolean {
  return (
    pathname === '/destek' && destekSekmesi(new URLSearchParams(search), destekVar) === 'destek'
  );
}
